"use client";

import * as React from "react";
import { CheckIcon, ChevronsUpDownIcon } from "lucide-react";

import { cn } from "../../lib/utils";
import { Button } from "./button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./command";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

export function Combobox({
  label = "Select",
  classes = {},
  data = [],
  renderItem = null,
  showSearch = true,
  keywords = ["label"],
  icon = null,
  buttonVariant = "outline",
  buttonSize = "default",
  popoverAlign = "center",
  defaultValue = "",
  dropdownIcon = (
    <ChevronsUpDownIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
  ),
}) {
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(defaultValue);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant={buttonVariant}
          size={buttonSize}
          role="combobox"
          aria-expanded={open}
          className={`w-[200px] font-normal truncate justify-start px-2 ${
            icon ? "space-x-2" : ""
          } ${classes.button}`}
        >
          {icon ? <div className="">{icon}</div> : ""}
          <div
            className={`flex-1 flex items-center justify-between w-[calc(100%_-_48px)] ${classes.labelContainer}`}
          >
            <span className={`truncate text-left`}>
              {value ? data.find((item) => item.value === value)?.label : label}
            </span>
            {dropdownIcon}
          </div>
        </Button>
      </PopoverTrigger>
      <PopoverContent
        className={`w-[200px] p-0 ${classes.popoverContent}`}
        align={popoverAlign}
      >
        <Command
        // shouldFilter={false}
        // filter={(value, search, keywords) => {
        //   console.log(value, search, keywords)
        //   const extendValue = value + ' ' + keywords.join(' ')
        //   if (extendValue.includes(search)) return 1
        //   return 0
        // }}
        >
          {showSearch ? <CommandInput placeholder="Search..." /> : ""}
          <CommandList>
            <CommandEmpty>No data found.</CommandEmpty>
            <CommandGroup>
              {data.map((item) => (
                <CommandItem
                  key={item.value}
                  value={item.value}
                  keywords={keywords}
                  onSelect={(currentValue) => {
                    setValue(currentValue === value ? "" : currentValue);
                    setOpen(false);
                  }}
                >
                  {renderItem ? (
                    renderItem(item, value)
                  ) : (
                    <>
                      <CheckIcon
                        className={cn(
                          "mr-2 h-4 w-4",
                          value === item.value ? "opacity-100" : "opacity-0"
                        )}
                      />
                      {item.label}
                    </>
                  )}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
